/* ==========================================================================
   Lane Eleven — Drop 001 teaser runtime
   Ported parameter-for-parameter from the design handoff prototype scripts
   (Lane Eleven Teaser v2.dc.html + Mobile Concepts #2a).
   - Drum + tumbling "1"s physics (rAF loop)
   - Stopwatch (100ms tick), desktop LAP/RESET (cap 11 -> "LANE 11")
   - Marker-circle draw/undraw (load intro + hover)
   - Email capture: intercept submit, fetch POST to Shopify customer form,
     optimistic success line with frozen stopwatch value
   ========================================================================== */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-le-teaser]');
    if (!root) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---------- stopwatch ---------- */

    var t0 = performance.now();
    var ms = 0;
    var submitted = false;
    var splits = [];

    function pad(n) { return String(n).padStart(2, '0'); }

    function fmt(v) {
      var h = pad(Math.floor(v / 3600000));
      var m = pad(Math.floor(v / 60000) % 60);
      var s = pad(Math.floor(v / 1000) % 60);
      var t = String(Math.floor(v / 100) % 10);
      return { h: h, m: m, s: s, t: t, label: h + ':' + m + ':' + s + '.' + t };
    }

    var swH = root.querySelector('[data-lt-sw-h]');
    var swM = root.querySelector('[data-lt-sw-m]');
    var swS = root.querySelector('[data-lt-sw-s]');
    var swT = root.querySelector('[data-lt-sw-t]');
    var mswM = root.querySelector('[data-lt-msw-m]');
    var mswS = root.querySelector('[data-lt-msw-s]');
    var mswT = root.querySelector('[data-lt-msw-t]');

    function renderClock() {
      var f = fmt(ms);
      if (swH) swH.textContent = f.h;
      if (swM) swM.textContent = f.m;
      if (swS) swS.textContent = f.s;
      if (swT) swT.textContent = f.t;
      if (mswM) mswM.textContent = f.m;
      if (mswS) mswS.textContent = f.s;
      if (mswT) mswT.textContent = f.t;
    }

    if (!reduced) {
      setInterval(function () {
        if (!submitted) {
          ms = performance.now() - t0;
          renderClock();
        }
      }, 100);
    }

    /* ---------- laps (desktop) ---------- */

    var lapsEl = root.querySelector('[data-lt-laps]');
    var lapBtn = root.querySelector('[data-lt-lap]');
    var resetBtn = root.querySelector('[data-lt-reset]');

    function renderLaps() {
      if (!lapsEl) return;
      lapsEl.textContent = '';
      for (var i = 0; i < splits.length; i++) {
        var row = document.createElement('div');
        row.className = 'lt-lap-row';
        var n = document.createElement('span');
        n.className = 'lt-lap-n';
        n.textContent = splits[i].n;
        var t = document.createElement('span');
        t.textContent = splits[i].t;
        row.appendChild(n);
        row.appendChild(t);
        lapsEl.appendChild(row);
      }
      if (lapBtn) {
        var full = splits.length >= 11;
        lapBtn.disabled = full;
        lapBtn.textContent = full ? 'LANE 11' : 'LAP';
      }
    }

    if (lapBtn) {
      lapBtn.addEventListener('click', function () {
        if (splits.length >= 11) return;
        splits.push({ n: pad(splits.length + 1), t: fmt(ms).label });
        renderLaps();
      });
    }

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        t0 = performance.now();
        ms = 0;
        splits = [];
        renderClock();
        renderLaps();
      });
    }

    /* ---------- drum + tumbling "1"s ---------- */

    var drums = [];
    var drumEls = root.querySelectorAll('[data-lt-drum]');
    for (var di = 0; di < drumEls.length; di++) {
      drums.push({
        el: drumEls[di],
        struct: drumEls[di].parentElement.querySelector('[data-lt-drum-struct]')
      });
    }

    var activeDrum = null;
    var garments = null;
    var angle = 0;

    function pickDrum() {
      for (var i = 0; i < drums.length; i++) {
        if (drums[i].el.clientWidth > 10) return drums[i];
      }
      return null;
    }

    function clearGarments() {
      if (garments) {
        for (var i = 0; i < garments.length; i++) {
          if (garments[i].el.parentElement) garments[i].el.parentElement.removeChild(garments[i].el);
        }
      }
      garments = null;
    }

    function mkGarments(R, drumEl) {
      // two solid 3D block "1"s — the #11 in the wash
      var tones = [
        ['#F8F3E9', '#BCB098', '#8F8674'],
        ['#F8F3E9', '#BCB098', '#8F8674']
      ];
      var D = 'M44 8 L68 8 L68 102 L44 102 L44 34 L27 42 L27 24 Z';
      return tones.map(function (c, i) {
        var el = document.createElement('div');
        var w = R * (0.62 + 0.08 * i);
        var h = w * 1.06;
        el.style.cssText = 'position:absolute;left:50%;top:50%;width:' + w + 'px;height:' + h +
          'px;will-change:transform;filter:drop-shadow(0 ' + (R * 0.02) + 'px ' + (R * 0.03) + 'px rgba(0,0,0,0.35));';
        var ext = '';
        for (var k = 4; k >= 1; k--) ext += '<path d="' + D + '" transform="translate(' + (k * 1.9) + ' ' + (k * 2.2) + ')" fill="' + (k === 1 ? c[1] : c[2]) + '"></path>';
        el.innerHTML =
          '<svg viewBox="0 0 100 110" style="width:100%;height:100%;display:block;overflow:visible;">' +
          ext +
          '<path d="' + D + '" fill="' + c[0] + '" stroke="' + c[2] + '" stroke-width="1.6" stroke-linejoin="round"></path>' +
          '<path d="M48 14 L48 96" fill="none" stroke="' + c[2] + '" stroke-width="1.4" opacity="0.25" stroke-linecap="round"></path>' +
          '</svg>';
        drumEl.appendChild(el);
        var th = Math.PI / 2 + (i - 0.5) * 0.6;
        return { el: el, gr: Math.max(w, h) / 2, th: th, travel: -((i * 1.9) % 1.4), rel: 1.6 + ((i * 3.3) % 1) * 1.1,
          state: 'stuck', x: 0, y: 0, vx: 0, vy: 0, rot: 0, vr: 0,
          sq: 1, sqv: 0, sqAng: 0, phase: i * 2.4 };
      });
    }

    // reduced motion: static drum — the two "1"s at rest at the bottom, no loop
    function placeStatic() {
      var d = pickDrum();
      if (d !== activeDrum) {
        clearGarments();
        activeDrum = d;
      }
      if (!activeDrum) return;
      var R = activeDrum.el.clientWidth / 2;
      if (R <= 10) return;
      if (!garments) garments = mkGarments(R, activeDrum.el);
      for (var i = 0; i < garments.length; i++) {
        var g = garments[i];
        var rw = R - g.gr * 0.66;
        var x = rw * Math.cos(g.th);
        var y = rw * Math.sin(g.th);
        var rot = g.th * 57.3 + 90;
        g.el.style.transform = 'translate(-50%,-50%) translate(' + x + 'px,' + y + 'px) rotate(' + rot + 'deg)';
      }
    }

    var lastT, stutterAt, stutterUntil, raf;

    function loop(t) {
      raf = requestAnimationFrame(loop);
      var dt = Math.min(t - lastT, 100) / 1000;
      lastT = t;
      if (t > stutterAt) {
        stutterUntil = t + 420;
        stutterAt = t + 5500 + Math.random() * 4500;
      }
      var w = t < stutterUntil ? 0 : 1.7; // rad/s, clockwise
      angle += w * dt * 180 / Math.PI;

      // one drum instance per active layout: animate only the visible drum
      var d = pickDrum();
      if (d !== activeDrum) {
        clearGarments();
        activeDrum = d;
      }
      if (!activeDrum) return;
      if (activeDrum.struct) activeDrum.struct.style.transform = 'rotate(' + angle + 'deg)';
      var R = activeDrum.el.clientWidth / 2;
      if (R > 10 && !garments) garments = mkGarments(R, activeDrum.el);
      if (garments) {
        var G = R * 5.2; // gravity px/s^2
        for (var i = 0; i < garments.length; i++) {
          var g = garments[i];
          var rw = R - g.gr * 0.66;
          var stretch = '';
          if (g.state === 'stuck') {
            g.th += w * dt;
            g.travel += w * dt;
            g.x = rw * Math.cos(g.th);
            g.y = rw * Math.sin(g.th);
            // cloth lies against the wall: ease rotation to tangent
            var target = g.th * 57.3 + 90;
            var dr = ((target - g.rot + 540) % 360) - 180;
            g.rot += dr * Math.min(1, dt * 5);
            if (g.travel > g.rel && w > 0.3) {
              g.state = 'fall';
              g.vx = -w * rw * Math.sin(g.th) * 0.92;
              g.vy = w * rw * Math.cos(g.th) * 0.45;
              g.vr = (dr > 0 ? 1 : -1) * (120 + Math.random() * 160);
            }
          } else {
            g.vy += G * dt;
            g.x += g.vx * dt;
            g.y += g.vy * dt;
            g.rot += g.vr * dt;
            var dist = Math.hypot(g.x, g.y);
            if (dist > rw) {
              g.x *= rw / dist; g.y *= rw / dist;
              var impact = Math.hypot(g.vx, g.vy);
              if (g.y > 0) { // landed in lower half -> re-stick with squash
                g.state = 'stuck';
                g.th = Math.atan2(g.y, g.x);
                g.travel = 0;
                g.rel = 1.6 + Math.random() * 1.1;
                g.sq = Math.max(0.55, 1 - impact / (R * 6));
                g.sqv = 0;
                g.sqAng = g.th * 57.3;
              } else { // grazed upper wall: shed speed, keep falling
                g.vx *= 0.4; g.vy *= 0.4;
              }
            }
            // cartoon stretch along velocity while airborne
            var vmag = Math.hypot(g.vx, g.vy);
            var s = 1 + Math.min(0.32, vmag / (R * 7));
            if (s > 1.02) {
              var va = Math.atan2(g.vy, g.vx) * 57.3;
              stretch = ' rotate(' + va + 'deg) scale(' + s + ',' + (1 / s) + ') rotate(' + (-va) + 'deg)';
            }
          }
          // jelly spring back from landing squash (overshoot = bounce)
          if (g.sq < 0.999) {
            g.sqv += (1 - g.sq) * 130 * dt;
            g.sqv *= Math.exp(-9 * dt);
            g.sq = Math.min(1.12, g.sq + g.sqv * dt);
            var wide = 1 + (1 - g.sq) * 0.85;
            stretch += ' rotate(' + g.sqAng + 'deg) scale(' + wide + ',' + g.sq + ') rotate(' + (-g.sqAng) + 'deg)';
          } else if (g.sq > 1) {
            g.sq = 1;
          }
          // soft cloth wobble while riding the drum
          var wob = '';
          if (g.state === 'stuck' && w > 0.3) {
            wob = ' skewX(' + (Math.sin(t * 0.004 + g.phase) * 5) + 'deg)';
          }
          g.el.style.transform = 'translate(-50%,-50%) translate(' + g.x + 'px,' + g.y + 'px)' + stretch + ' rotate(' + g.rot + 'deg)' + wob;
        }
      }
    }

    /* ---------- desktop stage fit ---------- */

    var stage = root.querySelector('[data-lt-stage]');

    function fitStage() {
      if (!stage) return;
      /* Everything visible, no scroll: uniform scale fits the 982px design
         height into the viewport, then the stage widens in CSS pixels to
         fill the remaining width (right-anchored / centered elements
         redistribute). clientWidth (not innerWidth) so a classic Windows
         scrollbar can never shift the layout. */
      var vw = document.documentElement.clientWidth;
      var vh = window.innerHeight;
      var s = Math.min(vw / 1512, vh / 982);
      var stageW = Math.max(1512, vw / s);
      stage.style.width = stageW + 'px';
      stage.style.transform = 'scale(' + s + ')';
      stage.style.left = ((vw - stageW * s) / 2) + 'px';
      stage.style.top = Math.max(0, (vh - 982 * s) / 2) + 'px';
      stage.parentElement.style.height = vh + 'px';

      /* Wordmark spans ~97% of the stage at any width. Capped so its
         bottom edge stays clear of the headline block (top: 255px). */
      var wm = stage.querySelector('.lt-wordmark');
      if (wm) wm.style.fontSize = Math.min(145 * stageW / 1512, 225) + 'px';

      /* On stages wider than the 1512 design, pull the headline and washer
         a quarter of the extra width inward — edges get breathing room,
         the gap to the centered email/CTA shrinks. At 1512 exactly this
         resolves to the spec insets (30 / 30 / 45). */
      var inset = 30 + (stageW - 1512) * 0.25;
      var hl = stage.querySelector('.lt-headline');
      var wz = stage.querySelector('.lt-washer-zone');
      var st = stage.querySelector('.lt-sticker--desktop');
      if (hl) hl.style.left = inset + 'px';
      if (wz) wz.style.right = inset + 'px';
      if (st) st.style.right = (inset + 15) + 'px';
    }

    fitStage();
    window.addEventListener('resize', function () {
      fitStage();
      if (reduced) placeStatic();
    });

    /* ---------- marker circle (desktop email field) ---------- */

    var markerPath = root.querySelector('[data-lt-marker-path]');
    var markerZone = root.querySelector('[data-lt-marker-zone]');
    var markerHover = false;

    function markerEnter() {
      markerHover = true;
      var el = markerPath;
      if (!el) return;
      if (reduced) { el.style.transition = 'none'; el.style.strokeDashoffset = 0; el.style.strokeOpacity = 1; return; }
      var cur = parseFloat(getComputedStyle(el).strokeDashoffset);
      el.style.transition = 'none';
      el.style.strokeDashoffset = (isNaN(cur) || cur < 0) ? 1 : cur;
      el.style.strokeOpacity = 1;
      el.getBoundingClientRect(); // flush so the transition starts from here
      el.style.transition = 'stroke-dashoffset 0.8s cubic-bezier(0.45,0,0.2,1)';
      el.style.strokeDashoffset = 0;
    }

    function markerLeave() {
      markerHover = false;
      var el = markerPath;
      if (!el) return;
      if (reduced) { el.style.transition = 'none'; el.style.strokeDashoffset = 1; el.style.strokeOpacity = 0; return; }
      var cur = parseFloat(getComputedStyle(el).strokeDashoffset);
      el.style.transition = 'none';
      el.style.strokeDashoffset = isNaN(cur) ? 0 : cur;
      el.getBoundingClientRect();
      // fade the stroke out over the last beat so the round line-cap can't
      // leave a dot at the path end once the erase completes
      el.style.transition = 'stroke-dashoffset 0.6s cubic-bezier(0.55,0,0.55,1), stroke-opacity 0.15s linear 0.45s';
      el.style.strokeDashoffset = -1;
      el.style.strokeOpacity = 0;
    }

    if (markerZone) {
      markerZone.addEventListener('mouseenter', markerEnter);
      markerZone.addEventListener('mouseleave', markerLeave);
    }

    if (!reduced && markerPath) {
      setTimeout(function () {
        var el = markerPath;
        if (!el || markerHover || submitted) return;
        el.style.strokeOpacity = 1;
        el.style.transition = 'stroke-dashoffset 0.9s cubic-bezier(0.45,0,0.2,1)';
        el.style.strokeDashoffset = 0;
        setTimeout(function () {
          var el2 = markerPath;
          if (!el2 || markerHover) return;
          el2.style.transition = 'stroke-dashoffset 0.7s cubic-bezier(0.55,0,0.55,1), stroke-opacity 0.15s linear 0.55s';
          el2.style.strokeDashoffset = -1;
          el2.style.strokeOpacity = 0;
        }, 2600);
      }, 1600);
    }

    /* ---------- email capture (both forms) ---------- */

    /* Native submit only. The previous build intercepted submit and fired an
       AJAX fetch to /contact — but Shopify's storefront captcha rejects that
       with HTTP 400 "Missing CAPTCHA token" (the fetch bypasses Shopify's own
       captcha-bootstrap, so no token is attached), and the swallowed error
       still showed a fake "you're in". Result: zero customers captured.
       Letting the form POST natively lets Shopify attach the captcha token,
       create the customer, and redirect back with form.posted_successfully?,
       which server-renders the .lt-success line. We only stash the frozen
       stopwatch so that success line can still read "clocked at HH:MM:SS.t". */

    function bindForm(form) {
      form.addEventListener('submit', function () {
        try { sessionStorage.setItem('lt-clocked', fmt(ms).label); } catch (err) {}
        submitted = true; // freeze the visible stopwatch during the redirect
      });
    }

    var forms = root.querySelectorAll('form.lt-form');
    for (var fi = 0; fi < forms.length; fi++) bindForm(forms[fi]);

    /* After the success redirect, fold the frozen stopwatch into the
       server-rendered success line (no-op if the stash or line is absent). */
    try {
      var clocked = sessionStorage.getItem('lt-clocked');
      if (clocked) {
        sessionStorage.removeItem('lt-clocked');
        var succ = root.querySelectorAll('.lt-success');
        for (var ci = 0; ci < succ.length; ci++) {
          succ[ci].textContent = "you're in. clocked at " + clocked + ". we'll be in touch.";
        }
      }
    } catch (err) { /* sessionStorage unavailable — leave the static line */ }

    /* ---------- start ---------- */

    renderClock();
    renderLaps();

    if (reduced) {
      placeStatic();
    } else {
      lastT = performance.now();
      stutterAt = lastT + 5000;
      stutterUntil = 0;
      raf = requestAnimationFrame(loop);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
